<script setup lang="ts">
import { useRoute } from 'vue-router';

import PaginationBtn from '@/components/btns/PaginationBtn.vue';
import PaginationSelectField from '@/components/fields/PaginationSelectField.vue';

export interface Props {
  length?: number;
  selected?: number;
  pageSize?: number;
}
const props = withDefaults(defineProps<Props>(), {
  length: 1,
  selected: 1,
  pageSize: undefined,
});

const route = useRoute();
</script>

<template>
  <div :class="$style.paginationCmn">
    <div :class="$style.textItem">Rows per page</div>
    <div :class="$style.selectItem">
      <PaginationSelectField
        hide-details
        :class="$style.select"
        :model-value="props.pageSize"
      />
    </div>
    <v-pagination
      :length="props.length"
      :total-visible="6"
      :model-value="props.selected"
      show-first-last-page
      :class="$style.pagination"
    >
      <template #first="{ icon, onClick, disabled }">
        <PaginationBtn
          :disabled="disabled"
          :to="{ query: { ...route.query, page: 1 } }"
        >
          <v-icon icon="mdi-page-first" />
        </PaginationBtn>
      </template>
      <template #prev="{ icon, onClick, disabled }">
        <PaginationBtn
          :disabled="disabled"
          :to="{ query: { ...route.query, page: props.selected - 1 } }"
        >
          <v-icon icon="mdi-chevron-left" />
        </PaginationBtn>
      </template>
      <template #item="{ isActive, key, page, props: itemProps }">
        <PaginationBtn
          :disabled="itemProps.disabled"
          :is-selected="isActive"
          :to="{ query: { ...route.query, page: key } }"
        >
          {{ page }}
        </PaginationBtn>
      </template>
      <template #next="{ icon, onClick, disabled }">
        <PaginationBtn
          :disabled="disabled"
          :to="{ query: { ...route.query, page: props.selected + 1 } }"
        >
          <v-icon icon="mdi-chevron-right" />
        </PaginationBtn>
      </template>
      <template #last="{ icon, onClick, disabled }">
        <PaginationBtn
          :disabled="disabled"
          :to="{ query: { ...route.query, page: props.length } }"
        >
          <v-icon icon="mdi-page-last" />
        </PaginationBtn>
      </template>
    </v-pagination>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/variables';

.paginationCmn {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
}
  .textItem {
    white-space: nowrap;
    margin-right: 16px;
  }
  .selectItem {
    margin-right: 26px;
  }
    .select {
      display: inline-block;
      vertical-align: middle;
    }
  .pagination {
    :global {
      ul.v-pagination__list {
        padding: 0;
        margin: -2.5px;
      }
      ul.v-pagination__list > li {
        margin: 2.5px;
      }
    }
  }
</style>
